module.exports = __webpack_public_path__ + "static/media/AvenirNext-Italic.574fc46a.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/AvenirNext-Italic.woff2
// module id = 1813
// module chunks = 0